import { Divider } from 'antd';
import React from 'react';

import { Error403Unauthorized } from '@app/components';
import { PREFIX } from '@app/constants/appPrefix';

import { useSchedule } from '@pages/WorkSchedule/hooks/useSchedule';

import {
  ScheduleHeader,
  ScheduleSidebar,
  ScheduleContent,
  ContainerLoader,
  ScheduleFooter,
} from '@pages/WorkSchedule/components';

import '@pages/WorkSchedule/styles/WorkSchedule.desktop.scss';
import '@pages/WorkSchedule/styles/WorkSchedule.tablet.scss';
import '@pages/WorkSchedule/styles/WorkSchedule.mobile.scss';

export const WorkSchedule: React.FC = () => {
  const {
    allPositions,
    selectedPositions,
    employeeIds,
    filters,
    isFilterByDays,
    positionsLoader,
    employees,
    selectedEmployees,
    photosAndMiddleNames,
    form,
    startTime,
    endTime,
    daysCount,
    spaceInDays,
    selectedDays,
    initialSchedules,
    currentMonth,
    renderedMonths,
    cellsPerRowCount,
    cellsContainerLoader,
    initialRecords,
    mode,
    cells,
    changingCells,
    deletingCells,
    handleScroll,
    cancelChanges,
    setSelectedDays,
    setSpaceInDays,
    setDaysCount,
    setFilterByDays,
    setSelectedPositions,
    showDevNotification,
    saveSchedules,
    filterByEmployees,
    moveUserToNewMonth,
    setMode,
    setChangingCells,
    setDeletingCells,
    IsScheduleView,
  } = useSchedule();

  if (!IsScheduleView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className={`${PREFIX}work-schedule`}>
      <div className={`${PREFIX}schedule`}>
        <ScheduleHeader
          filters={filters}
          isFilterByDays={isFilterByDays}
          form={form}
          startTime={startTime}
          endTime={endTime}
          daysCount={daysCount}
          spaceInDays={spaceInDays}
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
          setSpaceInDays={setSpaceInDays}
          setDaysCount={setDaysCount}
          setFilterByDays={setFilterByDays}
          showDevNotification={showDevNotification}
          setMode={setMode}
        />
        <Divider className="top-filters-divider" />

        <div className="sidebar-and-content">
          <>
            {(positionsLoader || cellsContainerLoader) && <ContainerLoader />}
            <ScheduleSidebar
              allPositions={allPositions}
              selectedPositions={selectedPositions}
              employeeIds={employeeIds}
              employees={employees}
              selectedEmployees={selectedEmployees}
              positionsLoader={positionsLoader}
              photosAndMiddleNames={photosAndMiddleNames}
              setSelectedPositions={setSelectedPositions}
              showDevNotification={showDevNotification}
              filterByEmployees={filterByEmployees}
            />
            <ScheduleContent
              employees={employees}
              selectedPositions={selectedPositions}
              employeeIds={employeeIds}
              filters={filters}
              selectedEmployees={selectedEmployees}
              photosAndMiddleNames={photosAndMiddleNames}
              daysCount={daysCount}
              spaceInDays={spaceInDays}
              selectedDays={selectedDays}
              initialSchedules={initialSchedules}
              currentMonth={currentMonth}
              renderedMonths={renderedMonths}
              cellsPerRowCount={cellsPerRowCount}
              startTime={startTime}
              endTime={endTime}
              initialRecords={initialRecords}
              handleScroll={handleScroll}
              showDevNotification={showDevNotification}
              moveUserToNewMonth={moveUserToNewMonth}
              mode={mode}
              cells={cells}
              changingCells={changingCells}
              deletingCells={deletingCells}
              setChangingCells={setChangingCells}
              setDeletingCells={setDeletingCells}
            />
          </>
        </div>

        <ScheduleFooter
          saveChangingSchedules={saveSchedules}
          cancelChanges={cancelChanges}
        />
      </div>
    </div>
  );
};
